// employee/reducers.ts
const initialState = {
    getDraftData: [],
    getDraftCount: null,
    createDraftData: null,
    updateDraftData: null,
    getDraftMetaMessage: null,
    getDraftSuccess: false,
    getDraftFailure: false,
    createDraftSuccess: false,
    createDraftFailure: false,
    updateDraftSuccess: false,
    updateDraftFailure: false,
    deleteDraftSuccess: false,
    deleteDraftFailure: false,
};

export default function DraftReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_DRAFT_SUCCESS': {
            return {
                ...state,
                getDraftSuccess: true,
                getDraftData: action.payload?.data?.data?.data,
                getDraftCount:action.payload?.data?.data?.meta?.total,
                getDraftFailure: false,
            }; 
        }
        case 'GET_DRAFT_FAILURE': {
            return {
                ...state,
                getDraftFailure: true,
                getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
                getDraftSuccess: false,
            };
        }
        case 'RESET_GET_DRAFT': {
            return {
                ...state,
                getDraftSuccess: false,
                getDraftFailure: false,
                getDraftData: [],
                getDraftMetaMessage: null,
            };
        }

        // case 'CREATE_DRAFT_SUCCESS': {
        //     return {
        //         ...state,
        //         createDraftSuccess: true,
        //         createDraftData: action.payload?.data?.data?.data,
        //         getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
        //         createDraftFailure: false,
        //     };
        // }
        // case 'CREATE_DRAFT_FAILURE': {
        //     return {
        //         ...state,
        //         createDraftFailure: true,
        //         getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
        //         createDraftSuccess: false,
        //     };
        // }
        // case 'RESET_CREATE_DRAFT': {
        //     return {
        //         ...state,
        //         createDraftSuccess: false,
        //         createDraftFailure: false,
        //         createDraftData: null,
        //         getDraftMetaMessage: null,
        //     };
        // }

        case 'UPDATE_DRAFT_SUCCESS': {
            return {
                ...state,
                updateDraftSuccess: true,
                updateDraftData: action.payload?.data?.data?.data,
                getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
                updateDraftFailure: false,
            };
        }
        case 'UPDATE_DRAFT_FAILURE': {
            return {
                ...state,
                updateDraftFailure: true,
                getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
                updateDraftSuccess: false,
            };
        }
        case 'RESET_UPDATE_DRAFT': {
            return {
                ...state,
                updateDraftSuccess: false,
                updateDraftFailure: false,
                updateDraftData: null,
                getDraftMetaMessage: null,
            };
        }

        // case 'DELETE_DRAFT_SUCCESS': {
        //     return {
        //         ...state,
        //         deleteDraftSuccess: true,
        //         getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
        //         deleteDraftFailure: false,
        //     };
        // }
        // case 'DELETE_DRAFT_FAILURE': {
        //     return {
        //         ...state,
        //         deleteDraftFailure: true,
        //         getDraftMetaMessage: action.payload?.data?.data?.meta?.message,
        //         deleteDraftSuccess: false,
        //     };
        // }
        // case 'RESET_DELETE_DRAFT': {
        //     return {
        //         ...state,
        //         deleteDraftSuccess: false,
        //         deleteDraftFailure: false,
        //         getDraftMetaMessage: null,
        //     };
        // }

        default: {
            return state;
        }
    }
}
